module.exports = __webpack_public_path__ + "static/assets/359b541fe4c1fbc53e21e80d52eb454c.svg";